import { createAsyncAction } from '@alycecom/utils';

import { ICodeRequestParams } from '../types/Request.types';

import { TCountry } from './countries.types';

const PREFIX = 'COUNTRIES';

export const fetchCountries = createAsyncAction<ICodeRequestParams, TCountry[]>(`${PREFIX}/FETCH`);
